import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Card, Col, Form, Input, Row, Select } from "antd";
import { cronTypeOptions } from "pages/Family/components/constants/constants";
import React from "react";

function FarmLands() {
  return (
    <Form.List name="farmlands">
      {(fields, { add, remove }) => (
        <>
          {fields.map(({ key, name, ...restField }) => (
            <Card key={key} className="mb-4 border rounded p-4 bg-gray-50">
              <Row gutter={16}>
                <Col xs={24} sm={12} lg={6}>
                  <Form.Item
                    {...restField}
                    name={[name, "name"]}
                    label="اسم الأرض"
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} lg={6}>
                  <Form.Item
                    {...restField}
                    name={[name, "areaHectares"]}
                    label="المساحة (دونم)"
                  >
                    <Input type="string" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} lg={6}>
                  <Form.Item
                    {...restField}
                    name={[name, "cropType"]}
                    label="نوع المحصول"
                    rules={[{ required: false, message: "اختر النوع" }]}
                  >
                    <Select
                      allowClear
                      showSearch
                      placeholder="اختر نوع المحصول"
                      options={cronTypeOptions}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} lg={6}>
                  <Form.Item
                    {...restField}
                    name={[name, "location"]}
                    label="الموقع"
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} lg={6}>
                  <Form.Item
                    {...restField}
                    name={[name, "deedNumber"]}
                    label="رقم السجل/الطابو"
                  >
                    <Input />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} lg={6}>
                  <Form.Item
                    {...restField}
                    name={[name, "estimatedValue"]}
                    label="القيمة التقديرية"
                  >
                    <Input />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} lg={6}>
                  <Form.Item
                    {...restField}
                    name={[name, "expectedAnnualIncome"]}
                    label="الدخل السنوي المتوقع"
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} lg={6}>
                  <Form.Item
                    {...restField}
                    name={[name, "notes"]}
                    label="ملاحظات"
                  >
                    <Input.TextArea rows={1} />
                  </Form.Item>
                </Col>
              </Row>

              <Button
                type="dashed"
                danger
                onClick={() => remove(name)}
                icon={<MinusCircleOutlined />}
              >
                حذف الأرض
              </Button>
            </Card>
          ))}

          <Form.Item>
            <Button
              type="dashed"
              onClick={() => add()}
              block
              icon={<PlusOutlined />}
            >
              إضافة أرض
            </Button>
          </Form.Item>
        </>
      )}
    </Form.List>
  );
}

export default FarmLands;
